module.exports = __webpack_public_path__ + "static/media/Kempegowda.0dfab1bd.png";